'use strict';

/**
 * Retrieve contextual quantity selector
 * @return {string} - device type
 */
function getDeviceType() {
    var deviceType = 'Desktop';
    var ua = navigator.userAgent;

    if (/(tablet|ipad|playbook|silk)|(android(?!.*mobi))/i.test(ua)) {
        deviceType = 'Tablet';
    }

    if (/Mobile|iP(hone|od)|Android|BlackBerry|IEMobile|Kindle|Silk-Accelerated|(hpw|web)OS|Opera M(obi|ini)/.test(ua)) {
        deviceType = 'Mobile';
    }

    return deviceType;
}

module.exports = {
    getDeviceType: getDeviceType
};
